import { CSSProperties } from 'react';

import { getSizedImageUrl } from '@bodilenergy/util';

type ImageThumbnailProps = {
  className?: string;
  imageUrl?: string | null;
  alt?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
};

const DEFAULT_SIZE = 200;

export const ThumbnailWithUrl = ({ imageUrl, style, alt, width = DEFAULT_SIZE, height }: ImageThumbnailProps) => {
  if (!imageUrl) {
    return null;
  }

  return (
    <img
      style={{ ...style, width, height }}
      loading='lazy'
      src={getSizedImageUrl(imageUrl, { width, height })}
      alt={alt}
    />
  );
};
